import $i18n from 'panda-i18n';
import moment from 'moment';
import { getLocale } from '@/locales/locale';

const locales = getLocale();

/**
 * @description 项目类型
 */
const PROJECT_TYPES = [
  {
    label: 'AE',
    value: '1',
  },

  {
    label: 'EF',
    value: '2',
  },

  {
    label: $i18n.get({ id: 'QT.Other.four_px', dm: '其他' }),
    value: '999',
  },
];

/**
 * @description 产品类型
 */
const PRODUCTION_TYPES = [
  {
    label: '2B',
    value: '1',
  },

  {
    label: '2C',
    value: '2',
  },

  {
    label: $i18n.get({ id: 'QT.Other.four_px', dm: '其他' }),
    value: '999',
  },
];

/**
 * @description 滞留看板 产品类型
 */
const TETENTION_LIST = [
  {
    label: '2B',
    value: '2B',
  },

  {
    label: '2C',
    value: '2C',
  },
];

/**
 * @description 操作环节
 */
const OPERAITION_STATUS = [
  {
    label: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'Distribution.four_px', dm: '配货' }),
    value: '2',
  },

  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: '3',
  },

  {
    label: $i18n.get({ id: 'CheckOut.four_px', dm: '签出' }),
    value: '4',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: '5',
  },

  {
    label: $i18n.get({ id: 'Identification.four_px', dm: '查验' }),
    value: '6',
  },

  {
    label: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    value: '7',
  },
];

/**
 * @description 在线状态
 */
const ONLINE_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '0',
  },

  {
    label: $i18n.get({ id: 'Idle.four_px', dm: '空闲' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'Online.four_px', dm: '在线' }),
    value: '2',
  },
];

/**
 * @description 入库-订单类型
 */
const ORDER_TYPES = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '0',
  },

  {
    label: $i18n.get({ id: 'InboundOrder.four_px', dm: '入库订单' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'TJDD.ReturnOrder.four_px', dm: '退件订单' }),
    value: '2',
  },
];

/**
 * @description 入库-SLA类型
 */
const SLA_TYPES = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '0',
  },

  {
    label: $i18n.get({ id: 'SXN.ValidityPeriod.four_px', dm: '时效内' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'UltraTimeliness.four_px', dm: '超时效' }),
    value: '2',
  },
];

/**
 * @description 入库-承运方式
 */
const CARRAGE_MODES = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: '4pxCarrier.four_px', dm: '4PX承运' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Spontaneous.four_px', dm: '自发' }),
    value: 'M',
  },
];

/**
 * @description 入库-运输方式
 */
const TRANSPORTATIONS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'Maritime.four_px', dm: '海运' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'AirTransport.four_px', dm: '空运' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'HighwayTruck.four_px', dm: '公路卡车' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'RailwayTrain.four_px', dm: '铁路火车' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'Express.four_px', dm: '快递' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'SelfExtractingInTheDatabase.four_px', dm: '在库自提' }),
    value: 'I',
  },
];

/**
 * @description 入库首页-各环节作业看板-筛选类型
 */
const FILTER_TYPES = [
  {
    label: $i18n.get({ id: 'Homework.four_px', dm: '作业量' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'Orders.four_px', dm: '订单数' }),
    value: '2',
  },
];

/**
 * @description 入库面板 - 首页
 */
const INBOUND_BOARD_TYPE = [
  {
    label: $i18n.get({ id: 'NotStarted.four_px', dm: '未开始' }),
    value: 'UN',
  },

  {
    label: $i18n.get({ id: 'Unloading.four_px', dm: '卸货' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Shelved.four_px', dm: '已上架' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'AbnormalUnloading.four_px', dm: '卸货异常' }),
    value: 'UE',
  },

  {
    label: $i18n.get({ id: 'AbnormalReceipt.four_px', dm: '收货异常' }),
    value: 'RE',
  },

  {
    label: $i18n.get({ id: 'ShelvingException.four_px', dm: '上架异常' }),
    value: 'PE',
  },
];

/**
 * @description 出库面板 - 首页
 */
const OUTBOUND_BOARD_TYPE = [
  {
    label: $i18n.get({ id: 'FailedToMatch.four_px', dm: '匹配失败' }),
    value: 'MF',
  },

  {
    label: $i18n.get({ id: 'ChangedNumberException.four_px', dm: '换号异常' }),
    value: 'CE',
  },

  {
    label: $i18n.get({ id: 'MoneyOrder.four_px', dm: '汇单' }),
    value: 'M',
  },

  {
    label: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    value: 'ST',
  },

  {
    label: $i18n.get({ id: 'PackagingIncludingUnsorted.four_px', dm: '打包（含未分拣）' }),
    value: 'PA',
  },

  {
    label: $i18n.get({ id: 'Delivery.four_px', dm: '发货' }),
    value: 'DG',
  },

  {
    label: $i18n.get({ id: 'OutOfStock.four_px', dm: '已出库' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'Cancel.four_px', dm: '取消' }),
    value: 'X',
  },
];

/**
 * @description 人员分布-首页
 */
const PERSON_TYPE = [
  {
    label: $i18n.get({ id: 'Unloading.four_px', dm: '卸货' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    value: 'PI',
  },

  {
    label: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    value: 'ST',
  },

  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'PA',
  },
];

/**
 * @description 效率状态 - 首页
 */
const EFFECT_TYPE = [
  {
    label: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    value: 'RECEIVE',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'PUTAWAY',
  },

  {
    label: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    value: 'PICK',
  },

  {
    label: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    value: 'SORTING',
  },

  {
    label: $i18n.get({ id: 'SinglePackage.four_px', dm: '单一打包' }),
    value: 'SINGLE_PACKING',
  },

  {
    label: $i18n.get({ id: 'CompositePackaging.four_px', dm: '复合打包' }),
    value: 'COMPOSITE_PACKING',
  },
];

/**
 * 首页 --- 入库看板
 */
const INBOUND_BOARD_DATA = [
  {
    module: $i18n.get({ id: 'NotStarted.four_px', dm: '未开始' }),
    value: 'UN',
    src: '/service/inbound/billboard/bookdetail',
    blank: true,
    state: {
      // defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },

    // qty: 60,
    // IC: 102,
    // PCS: 39,
  },
  {
    module: $i18n.get({ id: 'Unloading.four_px', dm: '卸货' }),
    value: 'U',
    src: '/order/inboundorder',
    state: {
      itaskStatus: ['F'],
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    value: 'R',
    src: '/order/inboundorder',
    state: {
      itaskStatus: ['U'],
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'P',
    src: '/order/inboundorder',
    state: {
      itaskStatus: ['V', 'P'],
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'Shelved.four_px', dm: '已上架' }),
    value: 'C',
    src: '/order/inboundorder',
    state: {
      itaskStatus: ['C'],
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'AbnormalUnloading.four_px', dm: '卸货异常' }),
    value: 'UE',
    src: '/inbound/DischargeTask/dischargeChart',
    state: {
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'AbnormalReceipt.four_px', dm: '收货异常' }),
    value: 'RE',
    src: '/inbound/receipt/abnormalList',
    state: {
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'ShelvingException.four_px', dm: '上架异常' }),
    value: 'PE',
    src: '/inbound/puton/abnormalList',
    state: {
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },
];

/**
 * 报表 --- 入库看板
 */
const SERVICE_INBOUND_BOARD_DATA = [
  {
    module: $i18n.get({ id: 'NotStarted.four_px', dm: '未开始' }),
    value: 'UN',
    src: '/service/inbound/billboard/bookdetail',
    blank: true,
    state: {
      // defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },

    session: {
      bookParams: '',
    },
  },

  {
    module: $i18n.get({ id: 'Unloading.four_px', dm: '卸货' }),
    value: 'U',
    src: '/order/inboundorder',
    state: {
      itaskStatus: ['F'],
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    value: 'R',
    src: '/order/inboundorder',
    state: {
      itaskStatus: ['U'],
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'P',
    src: '/order/inboundorder',
    state: {
      itaskStatus: ['V', 'P'],
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'Shelved.four_px', dm: '已上架' }),
    value: 'C',
    src: '/order/inboundorder',
    state: {
      itaskStatus: ['C'],
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'AbnormalUnloading.four_px', dm: '卸货异常' }),
    value: 'UE',
    src: '/inbound/DischargeTask/dischargeChart',
    state: {
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'AbnormalReceipt.four_px', dm: '收货异常' }),
    value: 'RE',
    src: '/inbound/receipt/abnormalList',
    state: {
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'ShelvingException.four_px', dm: '上架异常' }),
    value: 'PE',
    src: '/inbound/puton/abnormalList',
    state: {
      defaultTimeLabel: 'expectPutawayDate',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'OrderEndWarning', dm: '订单完结预警' }),
    value: 'FE',
    src: '/order/inboundorder',
    state: {
      defaultTimeLabel: 'expectPutawayDate',
      itaskOvertimeNoFinished: 'Y',
    },
  },
];

const OUTBOUND_BOARD_DATA = [
  {
    module: locales === 'en-US' ? 'Failed to match' : $i18n.get({ id: 'FailedToMatch.four_px', dm: '匹配失败' }),
    value: 'MF',
    src: '/outbound/pick/manualRemitNew',
    state: {
      tabStatus: 'inventoryMatchFailAnalyze',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },

    // qty: 60,
    // OC: 150,
    // PCS: 36,
  },

  {
    module:
      locales === 'en-US'
        ? 'Get tracking No. fail '
        : $i18n.get({ id: 'ChangedNumberException.four_px', dm: '换号异常' }),
    value: 'CE',
    src: '/order/outboundorder',
    state: {
      number: ['N', 'W'],
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: locales === 'en-US' ? 'Abnormal outbound' : $i18n.get({ id: 'OutboundException.four_px', dm: '出库异常' }),
    value: 'E',
    src: '/order/outboundorder',
    state: {
      order: ['E'],
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: locales === 'en-US' ? 'ToBeIntercepted' : $i18n.get({ id: 'ToBeIntercepted', dm: '待拦截' }),
    value: 'PI',
    src: '/order/outboundorder',
    state: {
      interceptStatus: ['INTERCEPT_REQUESTED'],
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: locales === 'en-US' ? 'to pick wave' : $i18n.get({ id: 'MoneyOrder.four_px', dm: '汇单' }),
    value: 'M',
    src: '/order/outboundorder',
    state: {
      order: ['N', 'W'],
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: locales === 'en-US' ? 'to pick ' : $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    value: 'P',
    src: '/order/outboundorder',
    state: {
      order: ['P', 'I'],
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: locales === 'en-US' ? 'to sort' : $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    value: 'ST',
    src: '/order/outboundorder',
    state: {
      order: ['C', 'Q'],
      orderType: ['MOS', 'MOD', 'S'],
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module:
      locales === 'en-US' ? 'to pack' : $i18n.get({ id: 'PackagingIncludingUnsorted.four_px', dm: '打包（含未分拣）' }),
    value: 'PA',
    src: '/order/outboundorder',
    state: {
      order: ['C', 'O', 'R'],
      orderType: ['SO', 'MOS', 'MOD', 'S'],
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: locales === 'en-US' ? 'to ship' : $i18n.get({ id: 'Delivery.four_px', dm: '发货' }),
    value: 'DG',
    src: '/order/outboundorder',
    state: {
      order: ['K'],
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: locales === 'en-US' ? 'Shipped' : $i18n.get({ id: 'OutOfStock.four_px', dm: '已出库' }),
    value: 'S',
    src: '/order/outboundorder',
    state: {
      order: ['S'],
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: locales === 'en-US' ? 'Intercepted' : $i18n.get({ id: 'Intercepted', dm: '已拦截' }),
    value: 'IN',
    src: '/order/outboundorder',
    state: {
      interceptStatus: ['INTERCEPT_CONFIRMED'],
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: locales === 'en-US' ? 'Cancelled' : $i18n.get({ id: 'Cancel.four_px', dm: '取消' }),
    value: 'X',
    src: '/order/outboundorder',
    state: {
      order: ['X'],
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'AlreadyAttached.four_px', dm: '已打托' }),
    value: 'PE',
    src: '/order/outboundorder',
    state: {
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },

  {
    module: $i18n.get({ id: 'PartialShipment', dm: '部分发货' }),
    value: 'T',
    src: '/order/outboundorder',
    state: {
      defaultTime: 'expectedOutboundTime',
      time: [moment().format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')],
    },
  },
  // {
  //   module: $i18n.get({ id: 'NotSynchronized.four_px', dm: '未同步' }),
  // },
];

const EFFICIENCY_DATA = [
  {
    name: $i18n.get({ id: 'CurrentOperations.four_px', dm: '当前作业量' }),
    type: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    person: 10,
  },

  {
    name: $i18n.get({ id: 'CurrentOperations.four_px', dm: '当前作业量' }),
    type: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    person: 23,
  },

  {
    name: $i18n.get({ id: 'CurrentOperations.four_px', dm: '当前作业量' }),
    type: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    person: 22,
  },

  {
    name: $i18n.get({ id: 'CurrentOperations.four_px', dm: '当前作业量' }),
    type: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    person: 16,
  },

  {
    name: $i18n.get({ id: 'CurrentOperations.four_px', dm: '当前作业量' }),
    type: $i18n.get({ id: 'SinglePackage.four_px', dm: '单一打包' }),
    person: 10,
  },

  {
    name: $i18n.get({ id: 'CurrentOperations.four_px', dm: '当前作业量' }),
    type: $i18n.get({ id: 'CompositePackaging.four_px', dm: '复合打包' }),
    person: 8,
  },

  {
    name: $i18n.get({ id: 'EstimatedNumberOfPeople.four_px', dm: '预计人数' }),
    type: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    person: 5,
  },

  {
    name: $i18n.get({ id: 'EstimatedNumberOfPeople.four_px', dm: '预计人数' }),
    type: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    person: 2,
  },

  {
    name: $i18n.get({ id: 'EstimatedNumberOfPeople.four_px', dm: '预计人数' }),
    type: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    person: 3,
  },

  {
    name: $i18n.get({ id: 'EstimatedNumberOfPeople.four_px', dm: '预计人数' }),
    type: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    person: 19,
  },

  {
    name: $i18n.get({ id: 'EstimatedNumberOfPeople.four_px', dm: '预计人数' }),
    type: $i18n.get({ id: 'SinglePackage.four_px', dm: '单一打包' }),
    person: 15,
  },

  {
    name: $i18n.get({ id: 'EstimatedNumberOfPeople.four_px', dm: '预计人数' }),
    type: $i18n.get({ id: 'CompositePackaging.four_px', dm: '复合打包' }),
    person: 13,
  },
];

const PERSON_DATA = [
  {
    name: $i18n.get({ id: 'NumberOfOnlineUsers.four_px', dm: '在线人数' }),
    type: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    key: 'R',
    person: 3,
  },

  {
    name: $i18n.get({ id: 'NumberOfOnlineUsers.four_px', dm: '在线人数' }),
    type: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    key: 'P',
    person: 6,
  },

  {
    name: $i18n.get({ id: 'NumberOfOnlineUsers.four_px', dm: '在线人数' }),
    type: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    key: 'PI',
    person: 8,
  },

  {
    name: $i18n.get({ id: 'NumberOfOnlineUsers.four_px', dm: '在线人数' }),
    type: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    key: 'PA',
    person: 4,
  },

  {
    name: $i18n.get({ id: 'NumberOfIdlePeople.four_px', dm: '空闲人数' }),
    type: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    person: 5,
  },

  {
    name: $i18n.get({ id: 'NumberOfIdlePeople.four_px', dm: '空闲人数' }),
    type: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    person: 19,
  },

  {
    name: $i18n.get({ id: 'NumberOfIdlePeople.four_px', dm: '空闲人数' }),
    type: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    person: 10,
  },

  {
    name: $i18n.get({ id: 'NumberOfIdlePeople.four_px', dm: '空闲人数' }),
    type: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    person: 1,
  },
];

const RED_DATA = [
  $i18n.get({ id: 'NotStarted.four_px', dm: '未开始' }),
  $i18n.get({ id: 'Unloading.four_px', dm: '卸货' }),
  $i18n.get({ id: 'AbnormalUnloading.four_px', dm: '卸货异常' }),
  $i18n.get({ id: 'AbnormalReceipt.four_px', dm: '收货异常' }),
  $i18n.get({ id: 'ShelvingException.four_px', dm: '上架异常' }),
  $i18n.get({ id: 'FailedToMatch.four_px', dm: '匹配失败' }),
  $i18n.get({ id: 'ChangedNumberException.four_px', dm: '换号异常' }),
];

const GREY_DATA = [
  $i18n.get({ id: 'Cancel.four_px', dm: '取消' }),
  $i18n.get({ id: 'Intercepted', dm: '已拦截' }),
  // $i18n.get({ id: 'NotSynchronized.four_px', dm: '未同步' }),
];

const HELP_LIST = [
  {
    title: $i18n.get({ id: 'StorageSectionOperationManual.four_px', dm: '入库段操作手册' }),
    link: '',
  },

  {
    title: $i18n.get({ id: 'OutboundSectionOperationManual.four_px', dm: '出库段操作手册' }),
    link: '',
  },

  {
    title: $i18n.get({ id: 'ReplenishmentOperationManual.four_px', dm: '补货操作手册' }),
    link: '',
  },

  {
    title: $i18n.get({ id: 'HowToObtainAnAccountAnd_391135322.four_px', dm: '如何获取操作账号及登录使用入门' }),
    link: '',
  },
];

const MESSAGE_LIST = [
  {
    title: $i18n.get({ id: 'PlanForLaunchAndUseOf_159218442.four_px', dm: 'AGV设备上线投入使用计划' }),
    link: '',
  },

  {
    title: $i18n.get({
      id: 'TheAuxiliaryWorkingHourRegistrationFeature_254163345.four_px',
      dm: '辅助工时登记功能上线',
    }),

    link: '',
  },

  {
    title: $i18n.get({ id: 'HeadquartersOperationWarehouseTraining.four_px', dm: '总部运营对仓培训' }),
    link: '',
  },

  {
    title: $i18n.get({ id: 'AgvEquipmentIsPlannedToBe_209049131.four_px', dm: 'AGV设备计划进行停产检修' }),
    link: '',
  },
];

/**
 * 入库看板
 */
const BOOK_TYPE = [
  {
    label: $i18n.get({ id: 'AutomaticReservation.four_px', dm: '自动预约' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'DeliveryAppointment.four_px', dm: '收货预约' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'ValueAddedReservation.four_px', dm: '增值预约' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'ArrangementReservation.four_px', dm: '排仓预约' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'QueueForAppointment.four_px', dm: '排队预约' }),
    value: 'R',
  },
];

// 入库订单状态
const BILLBOARD_INBOUND_ORDER_STATUS = [
  {
    label: $i18n.get({ id: 'Reviewed.four_px', dm: '已审核' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'Reserved.four_px', dm: '已预约' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'Unloaded.four_px', dm: '已卸货' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'Received.four_px', dm: '已收货' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'PartialShelving.four_px', dm: '部分上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Shelved.four_px', dm: '已上架' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },
];

/*
 * 人物画像
 */
// 人物配置标签
const PERSON_CONFIG_LABEL = [
  {
    label: $i18n.get({ id: 'SeriousAndErrorFree.four_px', dm: '认真不出错' }),
    value: 'earnest_make_no_mistakes',
  },

  {
    label: $i18n.get({ id: 'Experienced.four_px', dm: '经验丰富' }),
    value: 'experienced',
  },

  {
    label: $i18n.get({ id: 'DonTKnowSkills.four_px', dm: '不懂技巧' }),
    value: 'understand_the_skills',
  },

  {
    label: $i18n.get({ id: 'CanTDriveForklift.four_px', dm: '不会开叉车' }),
    value: 'drive_a_forklift',
  },

  {
    label: $i18n.get({ id: 'CanDriveForkliftTruck', dm: '会开叉车' }),
    value: 'FORK_TRUCK',
  },

  {
    label: $i18n.get({ id: 'HeavyCargoOperator', dm: '重货操作员' }),
    value: 'HEAVY_CARGO',
  },

  {
    label: $i18n.get({ id: 'GuipinDistrict', dm: '贵品区' }),
    value: 'VALUABLE',
  },

  {
    label: 'DDSS',
    value: 'DDSS',
  },

  {
    label: $i18n.get({ id: 'NoviceXiaobai', dm: '新手小白' }),
    value: 'experienced_A_1',
  },

  {
    label: $i18n.get({ id: 'WorkplaceCalf', dm: '职场牛犊' }),
    value: 'experienced_A_2',
  },

  {
    label: $i18n.get({ id: 'ThreeyearExamPreparationStudents', dm: '三年备考生' }),
    value: 'experienced_A_3',
  },

  {
    label: $i18n.get({ id: 'ExperiencedOldDrivers', dm: '经验丰富老司机' }),
    value: 'experienced_A_4',
  },

  {
    label: $i18n.get({ id: 'LazyCancerPatients', dm: '懒癌患者' }),
    value: 'efficiency_B_1',
  },

  {
    label: $i18n.get({ id: 'InefficientPoorStudents', dm: '低效差生' }),
    value: 'efficiency_B_2',
  },

  {
    label: $i18n.get({ id: 'PassedStudent', dm: '及格生' }),
    value: 'efficiency_B_3',
  },

  {
    label: $i18n.get({ id: 'HighEfficiencyAndExcellentStudents', dm: '高效优秀生' }),
    value: 'efficiency_B_4',
  },

  {
    label: $i18n.get({ id: 'EfficiencyElite', dm: '效率精英' }),
    value: 'efficiency_B_5',
  },

  {
    label: $i18n.get({ id: 'TheOldManPaced', dm: '老人踱步' }),
    value: 'travelingSpeed_C_1',
  },

  {
    label: $i18n.get({ id: 'Chronic', dm: '慢性子' }),
    value: 'travelingSpeed_C_2',
  },

  {
    label: $i18n.get({ id: 'Jogger', dm: '慢跑者' }),
    value: 'travelingSpeed_C_3',
  },

  {
    label: $i18n.get({ id: 'Runner', dm: '奔跑者' }),
    value: 'travelingSpeed_C_4',
  },

  {
    label: $i18n.get({ id: 'Speeders', dm: '飞驰者' }),
    value: 'travelingSpeed_C_5',
  },

  {
    label: $i18n.get({ id: 'LazyGrinkers', dm: '懒人磨洋工' }),
    value: 'effectiveWorkingHour_D_1',
  },

  {
    label: $i18n.get({ id: 'WorkingUnsaturated', dm: '工作不饱和' }),
    value: 'effectiveWorkingHour_D_2',
  },

  {
    label: $i18n.get({ id: 'WorkByPoint', dm: '按点工作' }),
    value: 'effectiveWorkingHour_D_3',
  },

  {
    label: $i18n.get({ id: 'WorkHard', dm: '兢兢业业' }),
    value: 'effectiveWorkingHour_D_4',
  },

  {
    label: $i18n.get({ id: 'OvertimeMadman', dm: '加班狂人' }),
    value: 'effectiveWorkingHour_D_5',
  },

  {
    label: $i18n.get({ id: 'LazyWorkers', dm: '懒工' }),
    value: 'quantityOfWork_E_1',
  },

  {
    label: $i18n.get({ id: 'DoingNothing', dm: '无所事事' }),
    value: 'quantityOfWork_E_2',
  },

  {
    label: $i18n.get({ id: 'GeneralWorker', dm: '普工' }),
    value: 'quantityOfWork_E_3',
  },

  {
    label: $i18n.get({ id: 'OperationPioneer', dm: '作业先锋' }),
    value: 'quantityOfWork_E_4',
  },

  {
    label: $i18n.get({ id: 'HomeworkMadman', dm: '作业狂人' }),
    value: 'quantityOfWork_E_5',
  },

  {
    label: $i18n.get({ id: 'ThreeWrongFour', dm: '差三错四' }),
    value: 'accuracy_F_1',
  },

  {
    label: $i18n.get({ id: 'HighErrorRate', dm: '出错率高' }),
    value: 'accuracy_F_2',
  },

  {
    label: $i18n.get({ id: 'Poor', dm: '差强人意' }),
    value: 'accuracy_F_3',
  },

  {
    label: $i18n.get({ id: 'HighAccuracy', dm: '准确性高' }),
    value: 'accuracy_F_4',
  },

  {
    label: $i18n.get({ id: 'AccurateOperation', dm: '精准作业' }),
    value: 'accuracy_F_5',
  },
];

// 具体画像
const PERSON_BOARD_LABELS = [
  {
    label: $i18n.get({ id: 'Efficiency.four_px', dm: '效率' }),
    value: 'efficiency',
  },

  {
    label: $i18n.get({ id: 'Experience.four_px', dm: '经验' }),
    value: 'experienced',
  },

  {
    label: $i18n.get({ id: 'Accuracy.four_px', dm: '准确性' }),
    value: 'accuracy',
  },

  {
    label: $i18n.get({ id: 'Homework.four_px', dm: '作业量' }),
    value: 'quantityOfWork',
  },

  {
    label: $i18n.get({ id: 'OperatingHours', dm: '操作工时' }),
    value: 'effectiveWorkingHour',
  },

  {
    label: $i18n.get({ id: 'WalkingSpeed.four_px', dm: '行走速度' }),
    value: 'travelingSpeed',
  },
];

const PERSON_BOARD_TYPE = [
  {
    label: $i18n.get({ id: 'Personal.four_px', dm: '个人' }),
    value: 'personal',
  },

  {
    label: $i18n.get({ id: 'FullWarehouseAverage.four_px', dm: '全仓平均' }),
    value: 'warehouse',
  },
];

// 入库订单状态
export const BILLBOARD_INBOUND_ORDER_STATUS_INBOUNDATA = [
  {
    label: $i18n.get({ id: 'Reviewed.four_px', dm: '已审核' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'Reserved.four_px', dm: '已预约' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'Unloaded.four_px', dm: '已卸货' }),
    value: 'U',
  },
  {
    label: $i18n.get({ id: 'ArrivedInTheWarehouse', dm: '已到仓' }),
    value: 'A',
  },
  {
    label: $i18n.get({ id: 'Received.four_px', dm: '已收货' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'PartialShelving.four_px', dm: '部分上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Shelved.four_px', dm: '已上架' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },
  {
    label: $i18n.get({ id: 'Summary.four_px', dm: '汇总' }),
    value: 'T',
  },
];

// 作业监控字典
export const LINKTIMESTATUS = [
  {
    label: $i18n.get({ id: 'PendingOrder.four_px', dm: '待汇单' }),
    value: 'PENDING_WAVE',
  },
  {
    label: $i18n.get({ id: 'ToBeSelected.four_px', dm: '待拣选' }),
    value: 'PENDING_PICK',
  },
  {
    label: $i18n.get({ id: 'Picking.four_px', dm: '拣选中' }),
    value: 'PICKING',
  },
  {
    label: $i18n.get({ id: 'ToBeSorted', dm: '待分拣' }),
    value: 'PENDING_ASSORT',
  },
  {
    label: $i18n.get({ id: 'SortingInProgress.four_px', dm: '分拣中' }),
    value: 'ASSORTING',
  },
  {
    label: $i18n.get({ id: 'ToBePackaged.four_px', dm: '待打包' }),
    value: 'PENDING_PACK',
  },
  {
    label: $i18n.get({ id: 'Packaging.four_px', dm: '打包中' }),
    value: 'PACKING',
  },
  {
    label: $i18n.get({ id: 'ToBeShipped', dm: '待发货' }),
    value: 'PENDING_SHIP',
  },
  {
    label: $i18n.get({ id: 'Summary.four_px', dm: '汇总' }),
    value: 'TOTAL',
  },
];

export {
  PROJECT_TYPES,
  PRODUCTION_TYPES,
  OPERAITION_STATUS,
  ONLINE_STATUS,
  ORDER_TYPES,
  SLA_TYPES,
  CARRAGE_MODES,
  TRANSPORTATIONS,
  FILTER_TYPES,
  PERSON_TYPE,
  EFFECT_TYPE,
  INBOUND_BOARD_TYPE,
  OUTBOUND_BOARD_TYPE,
  SERVICE_INBOUND_BOARD_DATA,
  INBOUND_BOARD_DATA,
  OUTBOUND_BOARD_DATA,
  EFFICIENCY_DATA,
  PERSON_DATA,
  RED_DATA,
  GREY_DATA,
  HELP_LIST,
  MESSAGE_LIST,
  TETENTION_LIST,
  BOOK_TYPE,
  BILLBOARD_INBOUND_ORDER_STATUS,
  PERSON_CONFIG_LABEL,
  PERSON_BOARD_LABELS,
  PERSON_BOARD_TYPE,
};
